import * as React from 'react';

import { ObservableHint } from '@legendapp/state';
import { use$ } from '@legendapp/state/react';

import DegreeImageContainer from '../degree-image/degree-image-container';

import ViewWrapper from '../product-view/view-wrapper';

import translate from '../../utils/translate';

import { containerStore, fullscreenStore, interiorStore, rootStore } from '../../store';
import { deviceSettingStore } from '../../store';
import BottomControlPanel from '../bottom-control-panel/bottom-control-panel';
import TopHeader from '../header/top-header';
import { HotAreas } from '../hot-areas/hot-areas';
import InteriorRender from '../interior-view/interior-render';
import { TwoDOnboarding } from '../onboarding/two-d-onboarding';
import ZoomControls from '../zoom-controls/zoom-controls';

const VISUALIZER_CONTAINER_ID = 'Visualizer_Feature_app';

// @TODO rename!!!
export default function App() {
	const isLoaded = use$(rootStore.isLoaded, { suspense: true });
	const isTouchDevice = use$(deviceSettingStore.isTouchDevice);
	const isInteriorLoaded = use$(interiorStore.isInteriorLoaded);
	const isTopHeaderVisible = use$(fullscreenStore.isTopHeaderVisible);

	return (
		isLoaded.bff && (
			<ViewWrapper
				id={VISUALIZER_CONTAINER_ID}
				role="region"
				aria-label={translate('global.ariaLabel.vehicleTurntableDescription')}
				ref={element => {
					if (element) {
						containerStore.container.set(ObservableHint.opaque(element));
					}
				}}
			>
				<DegreeImageContainer />
				{isInteriorLoaded && <InteriorRender />}
				{isTouchDevice && <HotAreas />}
				{isTopHeaderVisible && <TopHeader />}
				<TwoDOnboarding />
				<BottomControlPanel />
				{!isTouchDevice && <ZoomControls />}
			</ViewWrapper>
		)
	);
}
